module.exports = __webpack_public_path__ + "static/media/seo_bco.c4c102b7.svg";